import React from "react";
import { withRouter } from "react-router-dom";
import logo from "../../images/founder-logo-white.png";

function Header() {
  return (
    <div className='Header'>
      <div className='grid'>
        <a href="//foundersportgroup.com">
          <img className='logo' src={logo} alt='logo' />
        </a>
      </div>
    </div>
  );
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js